import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const FDRHeadingStyles = style({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: vars.space.xs,
  paddingBottom: vars.space.xs,
  paddingInlineStart: vars.space.xs,
  paddingInlineEnd: vars.space.xs,
});

export const HeaderStyles = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
});

export const EventNameAndDateStyles = style({
  textAlign: "center",
  color: vars.colors.onSurfaceVariant,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const SortingIconStyles = style({
  width: "10px",
  height: "auto",
  verticalAlign: "middle",
  color: vars.colors.onSurfaceVariant,
});

export const SortingWrapperStyles = style({
  cursor: "pointer",
});
